// Mirror of resolveTimeZone in packages/shared/src/utils/date-utils.ts —
// this app doesn't bundle @hijriya/shared. Keep the two in sync.
/**
 * IANA zones whose real-world rules changed after the tzdata many runtimes
 * still embed. Morocco (Africa/Casablanca, Africa/El_Aaiun) moved permanently
 * to GMT on 2026-09-20 at 02:00 local (IANA 2026c), but Node/ICU and browsers
 * built on older tzdata keep applying UTC+1 — showing the wrong clock and, on
 * the backend, rolling "today" over an hour early. Once every runtime ships
 * 2026c this mapping is a no-op (the zone resolves to UTC+0 either way).
 */
const TIMEZONE_OVERRIDES: { zones: string[]; from: number; zone: string }[] = [
  { zones: ['Africa/Casablanca', 'Africa/El_Aaiun'], from: Date.UTC(2026, 8, 20, 1), zone: 'UTC' },
];

/** The zone to hand to Intl for `timezone` at instant `at`, patching stale tzdata. */
export function resolveTimeZone(timezone: string, at: Date = new Date()): string {
  const override = TIMEZONE_OVERRIDES.find(o => o.zones.includes(timezone) && at.getTime() >= o.from);
  return override ? override.zone : timezone;
}
